import { postJson } from "../../services/api/ApiBase";

export interface PublicAccountConnectDetails {
  authorizationUri: string;
  workspace: { name: string; logo: string };
}

export const startPublicAccountConnect = (
  workspaceToken: string,
  provider: string,
  capabilities?: string[]
): Promise<PublicAccountConnectDetails> => {
  return postJson("/connect/start", { workspaceToken, provider, capabilities });
};

export const completePublicAccountConnect = (code: string, state: string) => {
  return postJson("/connect/complete", { code, state });
};

export const failPublicAccountConnect = (
  state: string,
  error: string,
  errorDescription?: string
) => {
  return postJson("/connect/fail", { state, error, errorDescription });
};

export interface SubAccountCreate {
  name: string;
  email: string;
}

export const saveSubAccount = (accountId: string, subAccount: SubAccountCreate) => {
  return postJson(`/connectedaccounts/${accountId}/subaccount`, subAccount);
};
